import { render } from "./TheScootersGenerals.vue?vue&type=template&id=f0017d3c"
import script from "./TheScootersGenerals.vue?vue&type=script&lang=js"
export * from "./TheScootersGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__